module.exports = __webpack_public_path__ + "img/word.c5e52a75.svg";